import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/login.css';
require('../../assets/css/main.css');
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function Login(props) {
    document.title = props.title
    const [userLoginNameValue, setLoginNameValue] = useState("");
    const [userLoginPasswordValue, setLoginPasswordValue] = useState("");

    const navigate = useNavigate();


    function onSubmitClick() {
        if (userLoginNameValue) {
            if (userLoginPasswordValue) {
                axios.post(config.API_URL + 'checkLogin', {
                    inputUserName: userLoginNameValue,
                    inputPassword: userLoginPasswordValue
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                }).then(function (response) {
                    console.log(response.data.data);
                    if (response.data.status.status == 1) {
                        console.log(response.data.data);
                        if (response.data.data.role_master_auto_id == 3) { // Role 2 For Teacher & 3 For Student
                            toast(response.data.status.message);
                            var JSONObj = {
                                role_master_auto_id: response.data.data.role_master_auto_id,
                                currentAcademicYear: response.data.data.currentAcademicYear,
                                LoginUserId: response.data.data.mstr_auto_id,
                                mstr_student_teacher_first_name: response.data.data.mstr_student_teacher_first_name,
                                mstr_student__teacher_middle_name: response.data.data.mstr_student__teacher_middle_name,
                                mstr_student_teacher_last_name: response.data.data.mstr_student_teacher_last_name,
                                mstr_student_teacher_email: response.data.data.mstr_student_teacher_email,
                                classSemester: response.data.data.classSemester,
                                courseName: response.data.data.courseName,
                                mstr_student_class: response.data.data.mstr_student_class,
                                mstr_student_class_semester: response.data.data.mstr_student_class_semester,
                                submittedFeedback: response.data.data.submittedFeedback,
                                mstr_student_course: response.data.data.mstr_student_course,
                                mstr_section_name: response.data.data.mstr_section_name,
                                mstr_student_degree: response.data.data.mstr_student_degree,
                                isAuthenticated: true,
                            };
                            localStorage.setItem('userDetailsLog', JSON.stringify(JSONObj));
                            localStorage.setItem("isAuthenticated", true);
                            // navigate('/StudentFeedback');
                            // navigate('/StudentDashboard');
                            navigate('/Student');
                        } else {
                            toast.success(response.data.status.message);
                            var JSONObj = {
                                role_master_auto_id: response.data.data.role_master_auto_id,
                                currentAcademicYear: response.data.data.currentAcademicYear,
                                LoginUserId: response.data.data.mstr_auto_id,
                                mstr_student_teacher_first_name: response.data.data.mstr_student_teacher_first_name,
                                mstr_student__teacher_middle_name: response.data.data.mstr_student__teacher_middle_name,
                                mstr_student_teacher_last_name: response.data.data.mstr_student_teacher_last_name,
                                mstr_teacher_designation: response.data.data.mstr_teacher_designation,
                                mstr_teacher_nature_of_oppintment: response.data.data.mstr_teacher_nature_of_oppintment,
                                mstr_teacher_year_of_experience: response.data.data.mstr_teacher_year_of_experience,
                                mstr_student_teacher_email: response.data.data.mstr_student_teacher_email,
                                mstr_teacher_department: response.data.data.mstr_teacher_department,
                                mstr_teacher_contact: response.data.data.mstr_student_teacher_contact_number,
                                submittedFeedback: response.data.data.submittedFeedback,
                                isAuthenticated: true,
                            };
                            localStorage.setItem('userDetailsLog', JSON.stringify(JSONObj));
                            localStorage.setItem("isAuthenticated", true);
                            navigate('/TeacherDashboard');
                            toast("Teacher Dashboard Work In Progress");
                        }
                    } else {
                        toast.error(response.data.status.message);
                    }
                    console.log(response.data.data);
                }).catch(function (error) {
                    toast.error(error);
                });
            } else {
                toast.error("Please enter password.");
            }
        } else {
            toast.error("Please enter login Username / Email Address.");
        }

    }

    const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
    return (
        <div className="login-module page-wrapper font-robo" >
            <div className="login-box">
                <div className="card card-1">
                    <div className="logo-holder">
                        <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                        <div className='feedback-title' >Feedback System</div>
                    </div>
                    <div className="card-body">
                        <form method="POST" name="form">
                            <div className='row'>
                                <div className="form-group  col-xs-12  col-sm-12 col-md-12">
                                    <label htmlFor="">Username / Email Address:</label>
                                    <input className="form-control" placeholder='Enter Username / Email Address' onChange={(e) => setLoginNameValue(e.target.value)} id="inputUserValue" type="text" />
                                </div>
                            </div>
                            <div className='row'>
                                <div className="form-group  col-xs-12  col-sm-12 col-md-12">
                                    <label htmlFor="">Password:</label>
                                    <input type="password" name="inputPassword" className="form-control" onChange={(e) => setLoginPasswordValue(e.target.value)} placeholder="Enter Password" />
                                </div>
                            </div>
                            <div className="p-t-20">
                                <button className="btn btn-primary btn-block" type="button" onClick={onSubmitClick} id='btnLogin'>Login</button>
                            </div>
                        </form>
                        <section className='section-footer'>
                            <div className='row'><div className='col-md-12'>
                                <div className='footer' style={{ textAlign: 'right', borderTop: 'none' }}>{config.PoweredBy}</div>
                            </div></div>
                        </section>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}